<template>
  <!-- 検査案件詳細 -->
  <div id="RequestDetail">
    <div id="container">
      <div class="labelTitle lable">検査案件詳細</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table id="requestDetailTable">
            <tr><th>受付番号</th><td colspan="2">{{item.receiptNumber}}
              <b-button v-if="canSalesInfoEdit" style="margin-left:5px; width:150px; float:right" class="is-primary" @click="recordSalesEdit">
                売上情報<template v-if="item.status != requestStatus.completionAppropriation">編集</template>
              </b-button></td>
            </tr>
            <tr><th>種別</th><td colspan="2">{{getKindGroupLabel(item.kind)}} <span v-if="isDemoRequest" class="demo"/><span v-if="isDepoRequest" class="depo"/></td></tr>
            <tr><th>機種名</th><td colspan="2">{{getKind(item.kind)}}</td></tr>
            <template v-if="item.type =='hst'">
              <tr><th>シリアル</th><td colspan="2">{{hstRequestDetail.serial}}</td></tr>
            </template>
            <tr><th>依頼元</th><td colspan="2">{{item.client}}<span v-if="item.proxyFlag" class="agent"/></td></tr>
            <tr><th>医療機関名</th><td colspan="2">{{item.hospital}}</td></tr>
            <tr><th>医師名</th><td colspan="2">{{item.doctorName}}</td></tr>
            <tr><th>事務担当者名</th><td colspan="2">{{item.clerkName}}</td></tr>
            <tr><th>申込日</th><td colspan="2">{{item.applicationDate}}　{{item.applicationUserName}}</td></tr>
            <tr><th>状態</th>
              <td colspan="2">
                <span :class='getTabClass4InternalStatus(item.status)'>{{getStatus(item.status)}}</span>
                <template v-if="item.status == requestStatus.reInspection"> <!--再検査調整中 -->
                  <b-icon  style="margin-top:7px; width:20px;" icon="arrow-right-bold-outline" />
                  <b-button v-if="item.type !='holter'" style="margin-left:5px; width:150px;" class="is-primary" @click="confirmReExamination('HST')">再検査を実施する</b-button>
                  <b-button v-if="item.type =='holter' && !isDepoRequest" style="margin-left:5px; width:150px;" class="is-primary" @click="confirmReExamination('Holter')">再検査を実施する</b-button>
                  <b-button v-if="item.type !='holter'" style="margin-left:5px; width:150px;" class="is-primary" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
                  <b-button v-if="item.type =='holter'" style="margin-left:5px; width:150px;" class="is-primary" @click="cancelReasonInputModalActiveh=true">検査をキャンセル</b-button>
                </template>
                <template v-if="canSales">
                  <b-icon  style="margin-top:7px; width:20px;" icon="arrow-right-bold-outline" />
                  <b-button style="margin-left:5px; width:150px;" class="is-primary" @click="showRecordSaleseArea">売上を計上する</b-button>
                </template>
              </td>
            </tr>
            <template v-if="item.status == requestStatus.completion || item.status == requestStatus.salesAppropriation || item.status == requestStatus.completionAppropriation">    <!--完了または完了（計上済み）-->
              <tr></tr>
              <tr><th>解析結果ファイル</th>
                <td colspan="2">
                  <ul>
                      <li v-for="(file ,index) in resultFiles" class="reportFiles" :key="index">
                        <a v-if="!(statusHistory[statusHistory.length -1].status == requestStatus.replaceReportFile && roleId != role.role_psc)" @click="downloadFile(file.path, file.fileId)" style="text-decoration: underline;"><b-icon icon="paperclip"/>{{file.name}}</a>
                        <span v-if="file.staffDLFlag" class="download"></span>
                      </li>
                  </ul>                  
                </td>
              </tr>
              <template v-if="item.deliveryslipFlag">
                <tr></tr>
                <tr><th>納品書</th>
                  <td style="width:800px;">
                    <span v-if="item.deliveryslipFlag" class="caution">納品書の添付が必要な案件です。</span> 
                  </td>
                  <td><b-button  v-if="!uploadMode" class="is-primary" style="margin:0 5px; height:36px;" @click="changeUploadMode">ファイルを追加する</b-button></td>
                </tr>
                <template v-if="uploadMode">
                  <tr><th></th>
                    <td>
                      <div class="upload_area uploadArea" @dragenter="dragEnter">
                        ここにファイルをドラッグアンドドロップするか、「ファイルを追加」を押します。
                      </div>
                      <b-modal :active.sync="isUpdateModal" has-modal-card>
                        <div class="modal-card uploadModal" 
                          @dragleave="dragLeave"
                          @drop.prevent="fileDorop"
                        >
                        ここに解析データファイルをドロップします。
                        </div>
                      </b-modal>
                    </td>
                    <td>
                      <b-upload v-model="upButtonFile" style="margin:0 5px;" class="file-label" v-on:input="addUploadfile" multiple>
                        <span class="file-cta">
                          <span class="file-label">ファイルを追加</span>
                        </span>
                      </b-upload>
                    </td>
                  </tr>
                  <tr><th></th>
                    <td>
                      <div style="margin-top:0px;">
                          <ul>
                              <li v-for="(file ,index) in voucherFiles" class="reportFiles" :key="'vo'+index">
                                <b-icon icon="paperclip"/>{{file.name}}
                              </li>
                              <li v-for="(file ,index) in upFileList" class="reportFiles" :key="'up'+index">
                                <b-icon icon="paperclip"/>{{file.name}} <a @click="removeUploadfile(index)" style="text-decoration: underline;"><b-icon icon="delete-forever-outline"/></a>
                              </li>
                          </ul>
                        </div>
                      </td>
                  </tr>
                  <tr><th></th>
                    <td style="padding-top: 20px; ">
                      <b-button style="width:150px;" class="is-primary" :disabled="upFileList.length == 0" @click="uploadVoucherFile" >アップロード</b-button>
                      <b-button style="margin-left:5px; width:150px;" class="is-primary" @click="addFileCancel" >キャンセル</b-button>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr><th></th>
                    <td>
                      <div>
                          <ul>
                              <li v-for="(file ,index) in voucherFiles" class="reportFiles" :key="index">
                                <a @click="downloadFile(file.path, file.fileId)" style="text-decoration: underline;"><b-icon icon="paperclip"/>{{file.name}}</a>
                              </li>
                          </ul>
                        </div>
                      </td>
                    <td></td>
                  </tr>
                </template>
              </template>
            </template>
            <tr></tr>
            <tr v-if="statusHistory.length > 0"><th>進捗状況</th>
              <td colspan="2">
                <template v-if="item.type =='hst' || item.type =='holter'">
                  <table class="flowTable" style="width:800px;">
                    <tr>
                      <td v-if="isDepoRequest" :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.deposit_regist) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.deposit_regist) ? 'account-check': 'account'" />
                        <div class="height30">院内貸出登録</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.deviceReady) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.deviceReady) ? 'account-check': 'account'" />
                        <div class="height30">受付</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.shippingReady) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.shippingReady) ? 'account-check': 'account'"/>
                        <div class="height30">機器準備</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.inspenction) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.inspenction) ? 'account-check': 'account'" />
                        <div class="height30">機器出荷</div>
                      </td>
                      <td v-if="isDepoRequest" :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.depositMachineRental) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.depositMachineRental) ? 'account-check': 'account'" />
                        <div class="height30">患者貸出</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.deviceReturn) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.deviceReturn) ? 'account-check': 'account'" />
                        <div class="height30">機器受領</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.analysisForwarding) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.analysisForwarding) ? 'account-check': 'account'" />
                        <div class="height30">解析依頼</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.resultComfirm) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.resultComfirm) ? 'account-check': 'account'" />
                        <div class="height30">解析</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.completion) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.completion) ? 'account-check': 'account'" />
                        <div class="height30">結果確認</div>
                      </td>
                      <td :class="isCanceled || isDemoRequest ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.completionAppropriation) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.completionAppropriation) ? 'account-check': 'account'" />
                        <div class="height30">売上計上</div>
                      </td>
                    </tr>
                  </table>
                </template>
                <template v-if="item.type =='psg' || item.type =='holterAnalysis'">
                  <table class="flowTable" style="width:800px;">
                    <tr>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.analysis) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.analysis) ? 'account-check': 'account'" />
                        <div class="height30">受付</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.analysis) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.analysis) ? 'account-check': 'account'" />
                        <div class="height30">解析依頼</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.resultComfirm) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.resultComfirm) ? 'account-check': 'account'" />
                        <div class="height30">解析</div>
                      </td>
                      <td :class="isCanceled ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.completion) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.completion) ? 'account-check': 'account'" />
                        <div class="height30">結果確認</div>
                      </td>
                      <td :class="isCanceled || isDemoRequest ? 'diagonalline' : ''">
                        <b-icon :class="(isComplete(requestStatus.completionAppropriation) ? 'complete': 'incomplete') + ' height30'" :icon="isComplete(requestStatus.completionAppropriation) ? 'account-check': 'account'" />
                        <div class="height30">売上計上</div>
                      </td>
                    </tr>
                  </table>
                </template>
              </td>
            </tr>
            <tr v-if="statusHistory.length > 0">
              <th></th>
              <td colspan="2">
                <table class="dateTable">
                  <tr><th style="width:70px;"> </th><th style="width:130px;">完了日</th><th>操作者</th><th class="h-center" style="width:300px;">詳細</th></tr>
                  <tr v-for="(history, index) in statusHistory" :key="index">
                    <th style="padding-left:0px; vertical-align: middle;">{{history.status | statusFilter}}  </th>
                    <td>{{history.completionDate}}</td>
                    <td v-if="history.isApi">自動 (API連携)</td>
                    <td v-else>{{history.operatorName}} ({{history.operatorBelongs}})</td>
                    <td style="padding:5px; vertical-align: middle;">
                      <!-- ESOCKETTIMEDOUTでのエラーメッセージ -->
                      <textarea v-if="history.memo.length > 0 && history.memo.indexOf('オーダー登録完了の確認ができませんでした。') != -1" v-model="history.memo" readonly style="height: 100px; resize: vertical; background-color:#F0E68C;"></textarea>
                      <textarea v-else-if="history.memo.length > 0" v-model="history.memo" readonly style="height: 50px; resize: vertical;"></textarea>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <hstRequestDetail v-if="item.type == 'hst' && hasDetailData"  v-bind:data="hstRequestDetail" :isHideAnalysisOptions="true"/>
        <psgRequestDetail v-if="item.type == 'psg' && hasDetailData"  v-bind:data="psgRequestDetail" :canUpdate="item.status == requestStatus.replaceFile" :isHideAnalysisOptions="true" @finish-psg="updateItem()"/>
        <holterRequestDetail v-if="item.type == 'holter' && hasDetailData"  v-bind:data="holterRequestDetail" v-bind:depositMachineFlag="item.depo" v-bind:depositMachineCancelNoDispFlag="isDepositCanceled" v-bind:isHideAnalysisOptions="true"/>
        <holterAnalysisRequestDetail v-if="item.type == 'holterAnalysis' && hasDetailData"  v-bind:data="holterAnalysisRequestDetail" :canUpdate="item.status == requestStatus.replaceFile" :isHideAnalysisOptions="true" @finish-psg="updateItem()"/>
      </div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
    </div>
    <floatingDiv v-if="isShowRecordSales" @close="closeRecordSalesArea" title="" width="580px" height="450px" top="100px" right="300px">
      <recordSales :salesInfo="salesInfo" :type="recordSalesDialogType" @close="closeRecordSalesArea" @recordSales="recordSales"/>
    </floatingDiv>
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="cancelInspection" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
    </b-modal>
    <b-modal :active.sync="cancelReasonInputModalActiveh" has-modal-card>
      <reasonInputModal  v-on:setReason="cancelInspectionh" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
    </b-modal>
  </div>
</template>

<script>
import { role, reExaminationConfirmTemplate } from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import {UploadType} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
import RecordSalesDetail from "@/components/mock/common/RecordSalesDetail";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import PSGRequestDetail from "@/components/mock/common/PSGRequestDetail";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import HolterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";

export default {
  name: "RequestDetail",
  methods: {
    back: function() {
      this.$router.push({
        name: "RequestSearch",
        params: {searchConditions: this.preSearchCondition}
      });
    },
    getHstRequestDetail: async function() {
      let _this = this;
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalHst.getHstRequestDetailPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.hstRequestDetail = result.obj.applicationDetails;
          _this.hasDetailData = true;
          _this.version = result.obj.version;
        },
        function(result) {
          console.log(result);
        }
      );
    },
    getPsgRequestDetail: async function() {
      let _this = this;
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalPsg.getPsgRequestDetailPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.psgRequestDetail = result.obj.applicationDetails;
          _this.hasDetailData = true;
        },
        function(result) {
          console.log(result);
        }
      );
    },
    getHolterRequestDetail: async function() {
      let _this = this;
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalHolter.getHolterRequestDetailPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.holterRequestDetail = result.obj.applicationDetails;
          _this.hasDetailData = true;
          _this.version = result.obj.version;
        },
        function(result) {
          console.log(result);
        }
      );
    },
    getHolterAnalysisRequestDetail: async function() {
      let _this = this;
      // Web Api Call
      // TODO 検査案件検索???STEP2
    },
    getRequestDetailFiles: async function() {
      let _this = this;
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalRequestSearch.getRequestDetailFilesPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.resultFiles = result.obj.resultFiles;
          _this.voucherFiles = result.obj.voucherFiles;          
        },
        function(result) {
        }
      );
    },
    // 再検査実施前の確認ダイアログ表示
    confirmReExamination(orderType) {
      var executeMethods;
      if(orderType == "HST") {
        executeMethods = this.doReInspection;
      } else if(orderType == "Holter") {
        executeMethods = this.doReInspectionh;
      }
      this.$dialog.confirm({
        title: "　",
        message: reExaminationConfirmTemplate.message,
        cancelText: reExaminationConfirmTemplate.cancelText,
        confirmText: reExaminationConfirmTemplate.confirmText,
        onConfirm: () => {
          executeMethods();
        },
      });
    },
    doReInspection: function() {
      //再検査を実施する
      let _this = this;
      var shortestShippingDateList = this.getShortestShippingDate()
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalRequestSearch.doReInspectionPOST({
            body:{
                kind: "hst",                
                receiptNumber:_this.item.receiptNumber,
                shortestShippingDateList:shortestShippingDateList,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.item.status =  requestStatus.deviceReady;
          _this.initPage();
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    doReInspectionh: function() {
      //再検査を実施する
      let _this = this;
      var shortestShippingDateList = this.getShortestShippingDate()
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalRequestSearch.doReInspectionPOST({
            body:{
                kind: "holter",                
                receiptNumber:_this.item.receiptNumber,
                shortestShippingDateList:shortestShippingDateList,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.item.status =  requestStatus.deviceReady;
          _this.initPage();
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    cancelInspection: function(reason){
      //検査をキャンセル
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalRequestSearch.cancelInspectionPOST({
            body:{
                kind: "hst",                
                receiptNumber:_this.item.receiptNumber,
                reason: reason,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.item.status =  requestStatus.cancel;
          _this.initPage();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    cancelInspectionh: function(reason){
      //検査をキャンセル
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalRequestSearch.cancelInspectionPOST({
            body:{
                kind: "holter",                
                receiptNumber:_this.item.receiptNumber,
                reason: reason,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.item.status =  requestStatus.cancel;
          _this.initPage();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    getStatusHistory: async function() {
      let _this = this;
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalRequestSearch.getStatusHistoryPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.statusHistory = result.obj;
          let ret = _this.statusHistory.find(history =>{
            return (history.status == _this.requestStatus.cancel) || (_this.item.status  == _this.requestStatus.depositMachineRelease) || (_this.item.status  == _this.requestStatus.depositMachineReturnWait);
          });
          _this.isCanceled = ret ? true: false;
          _this.isDepositCanceled = ret || !(_this.item.status == 2 || _this.item.status == 3 || _this.item.status == 21 || _this.item.status == 22) || !(userInfo.roleId == 1 || userInfo.roleId == 2 || userInfo.roleId == 6) ? true: false;
        },
        function(result) {
        }
      );
    },
    isComplete: function(targetStatus){
      var depositMachineRentalFlg = false;
      //履歴をさかのぼってチェックする
      for(let i = this.statusHistory.length -1 ; i > -1; i--){
        if(this.statusHistory[i].status == this.requestStatus.depositMachineRental){
          depositMachineRentalFlg = true;
        }
        if(this.statusHistory[i].status == this.requestStatus.reInspection){
          //再検査の場合
          if( targetStatus != this.requestStatus.deviceReady
           && targetStatus != this.requestStatus.analysis
           && targetStatus != this.requestStatus.deposit_regist)
           {
             if(depositMachineRentalFlg && (targetStatus == this.requestStatus.shippingReady || targetStatus == this.requestStatus.inspenction)){
               //院内貸出かつ再検査実施の場合
               return true;
             }
             //受付、院内貸出登録以外はfalse
             return false;
           }
           
        }
        if(this.statusHistory[i].status == targetStatus){
          return true;
        }
      }
      return false;
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            if (_this.resultFiles.length > 0) {
              var i = _this.resultFiles.findIndex(file => file.fileId == fileId);
              if (i >= 0) {
                var updfile = JSON.parse(JSON.stringify(_this.resultFiles[i]))
                updfile.staffDLFlag = result.obj.staffDLFlag;
                _this.resultFiles.splice(i, 1, updfile)
              }
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    recordSalesEdit: function() {
      if(this.item.status ==  requestStatus.completionAppropriation){
        this.recordSalesDialogType = "view";
      } else {
        this.recordSalesDialogType = "edit";
      }
      this.isShowRecordSales = true;
    },
    showRecordSaleseArea: function() {
      this.recordSalesDialogType = "sales";
      this.isShowRecordSales = true;
      this.item.status = requestStatus.salesAppropriation;
    },
    closeRecordSalesArea: function(){
      if(this.item.status ==  requestStatus.salesAppropriation){
        this.item.status =  this.status;
      }
      this.isShowRecordSales = false;
    },
    recordSales: async function() {
      this.item.status =  requestStatus.completionAppropriation;
      await this.getStatusHistory();
      this.canSales = false;
      this.closeRecordSalesArea();
    },
    changeUploadMode: function(){
      this.uploadMode = true;
    },
    addFile: function(){
      this.uploadMode = false;
    },
    addFileCancel: function(){
      this.upFileList = [];
      this.uploadMode = false;
    },
    uploadVoucherFile: async function(){
      let targetFile = this.upFileList;
      const nameList = targetFile.map(item => item['path']);
      for(let i = 0; i < nameList.length; i++){
        if(nameList[i].startsWith("/")){
          let zipName = nameList[i].replace("/", "");
          nameList[i] = zipName + ".zip"
        }
      }
      const setElements = new Set(nameList);
      if (setElements.size !== nameList.length) {
        this.showErrorMessage("名前が重複しているファイルが存在します。")
        return
      }
      let okSize = await this.checkUploadFileSize(targetFile);
      if(!okSize){
        this.showErrorMessage("2GBを超えるファイルはアップロードできません。");
        return
      }
      let _this = this
      this.multipleUpload(this.upFileList ,this.item.receiptNumber, this.UploadType.deliveryslip , "").then(result => {
        this.showMessage("登録が完了しました。", 
          async function(){
              await _this.getRequestDetailFiles();
              _this.upFileList = [];
              _this.uploadMode = false;
          });
        }).catch(error =>{
          this.showErrorMessage(error);
      });
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDorop: function(event) {
      let hasDirectory = false;
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(!entry.isDirectory){
          if(!this.upFileList.some(item=>{ return item.name == path;})){
            this.upFileList.push({ file: entry, path: path , name: path});
          }
        } else {
          hasDirectory = true;
        }
      }
      if(hasDirectory){
        this.showMessage("フォルダーは追加できません。"); 
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        if(!this.upFileList.some(item=>{ return item.name == upFile.name;})){
          this.upFileList.push({ file: upFile, path: upFile.name,name:upFile.name });
        }
      }
      this.upButtonFile = [];
    },
    removeUploadfile: function(index){
      this.upFileList.splice(index,1);
    },
    initPage: async function(){
      var appVue = this.$root.$children[0];
      appVue.loadingStart();
      if(this.item.type =="hst"){
        await this.getHstRequestDetail();
      } else if (this.item.type == "psg"){
        await this.getPsgRequestDetail();
      } else if (this.item.type =="holter"){
        await this.getHolterRequestDetail();
      } else if (this.item.type == "holterAnalysis"){
        await this.getHolterAnalysisRequestDetail();
      }
      await this.getStatusHistory();
      await this.getRequestDetailFiles();
      appVue.loadingEnd();
    },
    updateItem: async function(){
      var _this = this;
      this.apiCall(
        function(client){
          var obj = {
            receiptNumber: _this.item.receiptNumber,
          }
          return client.apis.internalRequestSearch.getRequestListPOST({
            body:obj
          });
        },
        async function(result){         
          if (result.obj.length > 0) {
            _this.item = result.obj[0]
          }
          await _this.getStatusHistory();
          await _this.getPsgRequestDetail();
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    }
  },
  data() {
    var item = this.$route.params["item"];
    var preSearchCondition = this.$route.params["searchConditions"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var canSalesInfoEdit= ( userInfo.roleId == role.role_admin || userInfo.roleId == role.role_salesOffice)
    var canSales= (  userInfo.roleId == role.role_admin
                 ||  userInfo.roleId == role.role_headOffice 
                 || userInfo.roleId == role.role_headOffice_sales
                 || userInfo.roleId == role.role_salesOffice)
                && (item.status == requestStatus.completion || item.status == requestStatus.salesAppropriation
                 || item.status == requestStatus.completionNotAccounted) //完了または売上計上中
                && item.demo !=  true
    var salesInfo  = {
        kind: item.type,
        receiptNumber: item.receiptNumber,
        customerCode:  item.customerCode,
        customerName:  item.customerName,
        salesOfficeCode: item.salesOfficeCode,
        salesStaffCode: item.salesStaffCode,
        shippingDate: item.shippingDate,
        itemCode:  item.itemCode,
        estimateCode:  item.estimateCode,
        patientName: item.patientName,
        hospital: item.hospital,
        inspectionDate: item.inspectionDate,
      };
    var roleId = "";
    if(userInfo){
      var roleId = userInfo.roleId;
    }
    return {
      UploadType:UploadType,
      preSearchCondition,
      requestStatus,
      hstRequestDetail:{},
      psgRequestDetail:{},
      holterRequestDetail:{},
      holterAnalysisRequestDetail:{},
      statusHistory: [],
      isShowRecordSales:false,
      canSalesInfoEdit: canSalesInfoEdit,
      canSales:canSales,
      recordSalesDialogType: "",
      item:item,
      resultFiles: [],
      voucherFiles: [],
      salesInfo: salesInfo,
      isCanceled: false,
      isDepositCanceled: false,
      isDemoRequest: item.demo,
      isDepoRequest: item.depo,
      uploadMode: false,
      isUpdateModal: false,
      upFileList: [],
      upButtonFile:null,
      cancelReasonInputModalActive:false,
      cancelReasonInputModalActiveh:false,
      hasDetailData: false,
      isShowReason:false,
      reason: "",
      status: item.status,
      role: role,
      roleId: roleId,
    };
  },
  filters: {
    statusFilter: function(value){
      let ret = "";
      if (value == requestStatus.inspectionRequest){//検査依頼中
        return "申込み"
      } else if (value == requestStatus.deviceReady){//機器準備中
        return "検査受付"
      } else if (value == requestStatus.shippingReady){//出荷準備中
        return "機器準備"
      } else if (value == requestStatus.inspenction){//検査中
        return "機器出荷"
      } else if (value == requestStatus.deviceReturn){//機器受領中
        return "機器受領"
      } else if (value == requestStatus.analysisForwarding){//解析依頼中
        return "解析依頼"
      } else if (value == requestStatus.analysisRequest){//解析依頼中
        return "申込み"
      } else if (value == requestStatus.analysis){//解析中
        return "解析受付"
      } else if (value == requestStatus.resultComfirm){//結果確認中
        return "解析"
      } else if (value == requestStatus.resultSendReady){//結果送付待
        return "結果送付待"
      } else if (value == requestStatus.kawagoeAcceptance){//川越受付中
        return "検診受付"
      } else if (value == requestStatus.jugdmentRequest){//判定依頼中
        return "判定依頼"
      } else if (value == requestStatus.completion){//完了
        return "結果承認"
      } else if (value == requestStatus.salesAppropriation){//売上計上中
        return "N/A"
      } else if (value == requestStatus.completionAppropriation){//完了（計上済）
        return "売上計上"
      } else if (value == requestStatus.reInspection){//再検査調整中
        return "再検査調整"
      } else if (value == requestStatus.cancel){//キャンセル
        return "キャンセル"
      } else if (value == requestStatus.replaceFile){//ファイル差し替え依頼
        return "データ差換え依頼"
      } else if (value == requestStatus.replaceFileFinish){//ファイル差し替え実施
        return "データ差換え実施"
      } else if (value == requestStatus.approvalRejecte){//承認却下
        return "却下"
      }else if (value == requestStatus.replaceReportFile){//完了後解析ファイル差替
        return "結果差替"
      }else if (value == requestStatus.replaceReportFileapproval){//完了後後差替ファイル承認
        return "結果差替承認"
      }else if (value == requestStatus.deposit_regist){
        return "院内貸出登録"
      }else if (value == requestStatus.depositMachineRental){
        return "患者貸出"
      }else if (value == requestStatus.depositMachineReturnWait){
        return "院内機回収中"
      }else if (value == requestStatus.depositMachineRelease){
        return "キャンセル"
      }
    }
  },
  components: {
    floatingDiv: floatingDiv,
    recordSales:RecordSalesDetail,
    hstRequestDetail:HSTRequestDetail,
    psgRequestDetail:PSGRequestDetail,
    holterRequestDetail:HolterRequestDetail,
    holterAnalysisRequestDetail:HolterAnalysisRequestDetail,
    reasonInputModal:reasonInputModal,
  },
  mounted: async function() {
    await this.initPage();
  }
};
</script>
<style lang="scss" scoped>
.tag {
  width: 150px !important;
  height: 36px !important;
}
#requestDetailTable th {
  vertical-align: top;
}
#requestDetailTable td {
  word-break: break-all ;
}
table.flowTable,
table.dateTable {
  border-collapse: collapse;
  table-layout: fixed;
}

table.flowTable tr,
table.flowTable td,
table.dateTable th,
table.dateTable tr,
table.dateTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 100px;
  text-align: center;
}
table.dateTable td {
  padding-left: 10px;
}
table.dateTable th {
  text-align: center;
}

.diagonalline {
  background-image: linear-gradient(
    to top right,
    transparent 0%,
    transparent 49.5%,
    #5f5f5f 49.5%,
    #5f5f5f 50.5%,
    transparent 50.5%,
    transparent 100%
  );
}
.caution,
.delay {
  color: red;
  margin-right:10px;
}
.delay {
  color: red;
  font-weight: bold;
}
.height30 {
  height:30px !important;
}
.reportFiles {
  float: left;
  margin-right:10px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.h-center {
  padding-left: 0 !important;
  text-align: center; 
  margin-left: auto;
  margin-right: auto;
}
.download::after {
  position: static;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/search/RequestDetail.vue